// extracted by mini-css-extract-plugin
export default {"InputFormNumber":"input-form-number_InputFormNumber__MC3oR","error":"input-form-number_error__-gHOJ"};